import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { ChangeLogsResponseDataSchema, DataResponseWithPagination } from "schema"
import { z } from "zod"

type Response = DataResponseWithPagination<z.infer<typeof ChangeLogsResponseDataSchema>>

const getChangeLogQueryKey = (model: string, id: string, page?: number, total?: number) => [
  "changeLog",
  model,
  id,
  page,
  total,
]

type Params = {
  model: string
  id: string
  page?: number
  total?: number
  onSuccess?: (data: Response) => void
}

export const changeLogQuery = (params?: Params) => {
  return queryOptions({
    queryKey: getChangeLogQueryKey(
      params?.model ?? "",
      params?.id ?? "",
      params?.page,
      params?.total,
    ),
    queryFn: async () => {
      if (!params?.model || !params?.id) {
        return { data: [], pageInfo: { count: 0 } }
      }

      const response = await axios.get<Response>(`/changeLog/${params.model}/${params.id}`, {
        params: {
          page: params.page,
          total: params.total,
        },
      })

      if (params?.onSuccess) {
        params.onSuccess(response.data)
      }

      return response.data
    },
    enabled: !!params?.model && !!params?.id,
  })
}
